import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react";


import type {
  ConsentState,
  PrivacyConfig,
} from "../types/index";


import {
  privacyTranslations,
} from "../i18n/translations";


import {
  getConsent,
  saveConsent,
} from "../services/storage";


import {
  emitConsentChange,
} from "../services/events";


import {
  removeCookiesByCategory,
} from "../services/cookieRegistry";



interface PrivacyContextValue {

  consent: ConsentState;

  hasConsent: boolean;

  updateConsent: (
    value: ConsentState
  ) => void;

  config: PrivacyConfig;

  services: PrivacyConfig["services"];

  translations: NonNullable<
    PrivacyConfig["translations"]
  >;

  preferencesOpen: boolean;

  openPreferences: () => void;

  closePreferences: () => void;

}




const defaultConsent: ConsentState = {

  necessary: true,

  analytics: false,

  marketing: false,

  preferences: false,

};





const PrivacyContext =
  createContext<
    PrivacyContextValue | undefined
  >(undefined);





interface PrivacyProviderProps {

  children: ReactNode;

  config: PrivacyConfig;

}







export function PrivacyProvider({

  children,

  config,

}: PrivacyProviderProps) {



  const [

    consent,

    setConsent

  ] =
    useState<ConsentState>(
      defaultConsent
    );



  const [

    hasConsent,

    setHasConsent

  ] =
    useState(false);



  const [

    preferencesOpen,

    setPreferencesOpen

  ] =
    useState(false);





  const translations =

    config.translations ??

    privacyTranslations[

      config.locale ?? "en"

    ];







  useEffect(() => {


    const saved =
      getConsent();




    if(saved){



      setConsent(

        saved.consent

      );



      setHasConsent(true);





      /*
        All'apertura della pagina
        sincronizza i cookie reali
        con il consenso salvato
      */


      if(!saved.consent.analytics){


        removeCookiesByCategory(

          config.services ?? [],

          "analytics"

        );


      }





      if(!saved.consent.marketing){


        removeCookiesByCategory(

          config.services ?? [],

          "marketing"

        );


      }





      if(!saved.consent.preferences){


        removeCookiesByCategory(

          config.services ?? [],

          "preferences"

        );


      }



    }



  },[]);









  function updateConsent(

    value: ConsentState

  ){





    /*
      Revoca consenso analytics
    */


    if(

      consent.analytics &&

      !value.analytics

    ){


      removeCookiesByCategory(

        config.services ?? [],

        "analytics"

      );


    }






    /*
      Revoca consenso marketing
    */


    if(

      consent.marketing &&

      !value.marketing

    ){


      removeCookiesByCategory(

        config.services ?? [],

        "marketing"

      );


    }






    /*
      Revoca consenso preferenze
    */


    if(

      consent.preferences &&

      !value.preferences

    ){


      removeCookiesByCategory(

        config.services ?? [],

        "preferences"

      );


    }







    saveConsent(

      value,

      config.policyVersion ?? "1.0",

      config.cookiePolicyVersion ?? "1.0"

    );




    setConsent(value);



    setHasConsent(true);



    emitConsentChange();



  }









  function openPreferences(){


    setPreferencesOpen(true);


  }







  function closePreferences(){


    setPreferencesOpen(false);


  }









  return (


    <PrivacyContext.Provider


      value={{


        consent,


        hasConsent,


        updateConsent,


        config,


        services:

          config.services ?? [],


        translations,


        preferencesOpen,


        openPreferences,


        closePreferences,


      }}


    >


      {children}


    </PrivacyContext.Provider>


  );

}









export function usePrivacyContext(){



  const context =

    useContext(

      PrivacyContext

    );



  if(!context){


    throw new Error(

      "usePrivacyContext must be used inside PrivacyProvider"

    );


  }



  return context;


}